<ul class="alg-tree" role="tree">
  <li class="alg-tree__item" *ngFor="let node of treeData; trackBy: trackByNodeId">
    <!-- « Charger les dossiers suivants » : une action, pas un noeud du depot. -->
    <button *ngIf="node.loadNext" type="button" class="alg-tree__more" (click)="loadNext(node.nodeParentId)">
      <mat-icon>more_horiz</mat-icon>
      <span class="alg-tree__label">{{ node.name }}</span>
    </button>

    <ng-container *ngIf="!node.loadNext">
      <div class="alg-tree__row" role="treeitem" [attr.aria-selected]="!!node.current"
           [class.alg-tree__row--current]="node.current" [class.alg-tree__row--empty]="node.empty"
           [class.alg-tree__row--file]="node.isFile">
        <!--
          Deux cibles distinctes, la ou l'icone de dossier faisait tout : le chevron ouvre ou ferme,
          le nom navigue. Ce sont deux gestes differents, ils meritent deux boutons — et de vrais
          `<button>`, pour le clavier et les lecteurs d'ecran.

          Un fichier, ou un dossier connu comme vide, n'a pas de chevron : la place est conservee
          par un espaceur pour que les libelles restent alignes.
        -->
        <button
          *ngIf="canExpand(node)"
          type="button"
          class="alg-tree__toggle"
          [attr.aria-expanded]="!!node.expanded"
          [attr.aria-label]="(node.expanded ? 'Replier ' : 'Deplier ') + node.name"
          (click)="toggleNode(node)"
        >
          <mat-icon>{{ node.expanded ? 'expand_more' : 'chevron_right' }}</mat-icon>
        </button>
        <span *ngIf="!canExpand(node)" class="alg-tree__toggle-spacer" aria-hidden="true"></span>

        <button type="button" class="alg-tree__link" [attr.aria-current]="node.current ? 'page' : null"
                [title]="node.name" (click)="navigateTo(node)">
          <!--
            Fichier : l'icone vient du type MIME, resolue par le meme service que la liste de
            documents — donc les memes icones dans les deux vues.
          -->
          <img *ngIf="node.isFile" class="alg-tree__icon" [src]="fileIcon(node)" [alt]="node.mimeType || ''" />
          <mat-icon *ngIf="!node.isFile" class="alg-tree__icon alg-tree__icon--folder">
            {{ node.expanded ? 'folder_open' : 'folder' }}
          </mat-icon>
          <span class="alg-tree__label">{{ node.name }}</span>
        </button>
      </div>

      <app-tree-nodes
        *ngIf="node.expanded && node.children"
        [rootNode]="rootNode || treeData"
        [treeData]="node.children"
        (fileSelected)="fileSelected.emit($event)"
      >
      </app-tree-nodes>
    </ng-container>
  </li>
</ul>
